import { render, staticRenderFns } from "./AbkSurveyStep2Form.vue?vue&type=template&id=771e60c8&scoped=true&"
import script from "./AbkSurveyStep2Form.vue?vue&type=script&lang=js&"
export * from "./AbkSurveyStep2Form.vue?vue&type=script&lang=js&"
import style0 from "./AbkSurveyStep2Form.vue?vue&type=style&index=0&id=771e60c8&lang=scss&scoped=true&"
import style1 from "./AbkSurveyStep2Form.vue?vue&type=style&index=1&id=771e60c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771e60c8",
  null
  
)

export default component.exports